export class Deferred {
    constructor() {
        this.isPending = true;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = (value) => {
                this.isPending = false;
                resolve(value);
            };
            this.reject = (reason) => {
                this.isPending = false;
                reject(reason);
            };
        });
    }
}
// Custom Promise wrapper to track state
export class TrackablePromise {
    constructor(promise) {
        this._state = 'pending';
        this.promise = promise;
        this.promise
            .then(() => {
            this._state = 'fulfilled';
        })
            .catch(() => {
            this._state = 'rejected';
        });
    }
    get state() {
        return this._state;
    }
    then(onfulfilled, onrejected) {
        return this.promise.then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.promise.catch(onrejected);
    }
}
//# sourceMappingURL=asyncUtils.js.map